import { render, staticRenderFns } from "./SuggestResponsibilitiesNavigator.vue?vue&type=template&id=773a76a9&scoped=true"
import script from "./SuggestResponsibilitiesNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestResponsibilitiesNavigator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SuggestResponsibilitiesNavigator.vue?vue&type=style&index=0&id=773a76a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a76a9",
  null
  
)

export default component.exports